// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__3_rOV","tip-title":"Tip_tip-title__J8eO8","tip-text":"Tip_tip-text__R2Ebj"};